const HAVE_METADATA = 1

export type ControllableVideo = {
    currentTime: number
    pause: () => void
    play: () => Promise<unknown>
    readyState?: number
    addEventListener?: (type: 'loadedmetadata', listener: () => void, options?: { once?: boolean }) => void
}

export function resetAndPlayVideos(videos: Iterable<ControllableVideo>) {
    for (const video of videos) {
        const start = () => {
            video.currentTime = 0
            video.play().catch(() => undefined)
        }

        if (typeof video.readyState !== 'number' || video.readyState >= HAVE_METADATA) {
            start()
            continue
        }

        video.addEventListener?.('loadedmetadata', start, { once: true })
    }
}

export function resetAndPlayVideosInContainer(container: ParentNode) {
    const playFound = () => {
        const videos = container.querySelectorAll('video')
        if (videos.length === 0) return false
        resetAndPlayVideos(videos)
        return true
    }

    if (playFound()) return

    requestAnimationFrame(() => {
        if (playFound()) return
        requestAnimationFrame(() => {
            playFound()
        })
    })
}

export function resetAndPauseVideos(videos: Iterable<ControllableVideo>) {
    for (const video of videos) {
        video.pause()
        video.currentTime = 0
    }
}

export function pauseVideosOutsideContainer<T extends ControllableVideo>(
    videos: Iterable<T>,
    containerContains: (video: T) => boolean,
) {
    for (const video of videos) {
        if (!containerContains(video)) video.pause()
    }
}
